import messaging from '@react-native-firebase/messaging'
import { PermissionsAndroid, Platform } from 'react-native'

export const register = async ({ onRegister, onNotification }) => {
  messaging()
    .getToken()
    .then(token => {
      console.log('-------> REGISTERED...', token)
      onRegister(token)
    })
    .catch(err => {
      console.log('----------> ERROR GETTING TOKEN!!!:', err)
    })

  const handleNotification = notif => {
    console.log('-----------> NOTIFICATION DATA:', notif.data)

    const { appId, target, ...params } = notif.data
    const route = { target, params }

    onNotification(route)
  }

  const handleForegroundNotification = notif => {
    const { title, body } = notif.notification
    const { appId, target, ...params } = notif.data
    const route = { target, params }

    onNotification(route, { title, body })
  }

  messaging().onNotificationOpenedApp(handleNotification)
  messaging().onMessage(handleForegroundNotification)

  const notificationOpen = await messaging().getInitialNotification()

  if (notificationOpen) {
    handleNotification(notificationOpen)
  }
}

export const requestPermission = () => {
  console.log(
    'Requesting notifications permission is required only for android 13 or above'
  )

  if (Number(Platform.constants.Release) >= 13) {
    PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS
    )
  }
}
